import LoginScreen from "@/screens/onboarding/LoginScreen"

export default LoginScreen
